const overlay = document.getElementById('overlay');
overlay.addEventListener('click', clearOverlay);

function toggleOverlay()
{
    document.querySelector('body').classList.toggle('modal-open');
    overlay.classList.toggle('show');
}

function clearOverlay()
{
    document.querySelector('body').classList.remove('modal-open');
    overlay.classList.remove('show');

    if ( mobileMenu.classList.contains('show') ) {
        closeMobileMenu();
    }

    if ( mobileCurrencySwitcherForm.classList.contains('visible') ) {
        mobileCurrencySwitcherForm.classList.remove('visible');
    }
}

const menuButton = document.getElementById("hamburger");
const mobileMenu = document.getElementById("mobile-menu");
const closeMenuButton = document.getElementById('menu-close');

menuButton.addEventListener('click', toggleMobileMenu);
closeMenuButton.addEventListener('click', toggleMobileMenu);

function toggleMobileMenu()
{
    toggleOverlay();


    if(mobileMenu.classList.contains('show')) {
        closeMobileMenu();
    } else {
        mobileMenu.classList.add("show");
    }


}

function closeMobileMenu()
{
    const openSubMenuItems = document.querySelectorAll('.mobile-menu-holder .mobile-sub-menu.show');


    openSubMenuItems.forEach(function(item) {

        item.classList.remove('show');

    })

    mobileMenu.classList.remove('show');


}


/* Show the mobile sub-menus when clicked */
const subMenuItems = document.querySelectorAll('.mobile-menu-holder > ul > li');
subMenuItems.forEach(function(item) {
    item.addEventListener('click', revealSubMenu);
})

function revealSubMenu(e)
{

    const subMenu = e.target.querySelector(".mobile-sub-menu");

    subMenu.classList.toggle('show');
}

const subMenuClose = document.querySelectorAll(".mobile-sub-menu .close");

subMenuClose.forEach(function(item) {
    item.addEventListener('click', closeSubMenu);
})

function closeSubMenu(e)
{

    e.stopPropagation();

    const subMenu = e.target.parentElement;

    subMenu.classList.toggle('show');
}

/* Adjust the padding so sub-menu doesn't get hidden under sticky menu. */

adjustSubMenu();

window.addEventListener("resize", adjustSubMenu);

function adjustSubMenu()
{
    const stickyHeader = document.getElementById('sticky-header');
    const headerHeight = stickyHeader.offsetHeight;
    const subHeader = document.getElementById('sub-header');
    subHeader.style.paddingTop = headerHeight + "px";
}



/* ---------- Mobile Currency Switcher ---------- */

const mobileCurrencySwitcherButton = document.querySelector( '.header-container__a' );
const mobileCurrencySwitcherForm = document.getElementById('mobile-currency-switcher');
if (mobileCurrencySwitcherButton) {
    mobileCurrencySwitcherButton.addEventListener('click', toggleMobileCurrencySwitcher);
}

function toggleMobileCurrencySwitcher()
{
    if ( window.innerWidth < 750 ) {
        if ( mobileCurrencySwitcherForm && mobileCurrencySwitcherForm.classList.contains('visible') ) {
            clearOverlay()
            mobileCurrencySwitcherForm.classList.remove('visible');
        } else if ( mobileCurrencySwitcherForm ) {
            toggleOverlay();
            mobileCurrencySwitcherForm.classList.add('visible');
        }
    }
}



/* ---------- Products Grid View Switcher ---------- */

/* Checks if the user has previosuly toggled the Producst Grid view, if so then default to whatever they last viewed it as */
document.addEventListener( 'DOMContentLoaded', maybeGetUserViewPreference );
function maybeGetUserViewPreference() {
    let viewPreference = localStorage.getItem('lfd_products_grid_view_preference');
    if ( viewPreference?.length ) {
        if ( viewPreference === 'list' ) {
            const productGridAncestor = document.getElementById('MainContent');

            /* Toggle class on Product Grid card container */
            productGridAncestor.classList.toggle('list-view');

            /* Switch the Icon */
            toggleProductsGridViewButtonIcon()
            
        }
    } else {
        localStorage.setItem('lfd_products_grid_view_preference', 'grid' );
    }
}

/* Adds the onClick for the toggle switch between Grid/List view in the Products Grid.
   Use event delegation so the handler survives cloud-search DOM re-renders. */
document.addEventListener('click', function(e) {
    if (e.target.closest('.grid-list-view-switch')) {
        toggleProductsGridView();
        toggleStoredUserViewPreference();
    }
});

 /* Toggle the view preference kept in localStorage */
function toggleStoredUserViewPreference() {
    let currentViewPreference = localStorage.getItem('lfd_products_grid_view_preference');
    if ( currentViewPreference === 'grid' ) {
        localStorage.setItem('lfd_products_grid_view_preference', 'list' );
    } else {
        localStorage.setItem('lfd_products_grid_view_preference', 'grid' );
    }
}

function toggleProductsGridViewButtonIcon() {
    /* Switch the Icon */
    const listViewButtons = document.querySelectorAll('.grid-list-view-switch');
    [...listViewButtons].forEach( listViewButton => {
        Array.from(listViewButton.children).forEach( el => {
            el.classList.toggle('hidden');
        });
    });
}

/* Visually switch between Grid/List layouts */
function toggleProductsGridView() {
    const productGridAncestor = document.getElementById('MainContent');

    /* Toggle class on Product Grid card container */
    productGridAncestor.classList.toggle('list-view');
    
    toggleProductsGridViewButtonIcon();
}









